import { BillingPeriod } from "@redotech/redo-billing-common/service-invoice";
import { orderTrackingCurrentUsageDataSchema } from "@redotech/redo-billing-common/tracking/tracking-billing-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const currentOrderTrackingBillingSummary = z.object({
  subscriptionPrice: z.number(),
  totalInvoicePrice: z.number(),
  billingDueDate: z.date(),
  period: createEnum(BillingPeriod),
  usage: orderTrackingCurrentUsageDataSchema,
  bundleDisclaimer: z.string().nullable(),
  bundlePercentOff: z.number().nullable(),
});

export type CurrentOrderTrackingBillingSummary = z.infer<
  typeof currentOrderTrackingBillingSummary
>;

export const getCurrentOrderTrackingInvoice = {
  name: "getCurrentOrderTrackingInvoice" as const,
  input: z.null(),
  output: currentOrderTrackingBillingSummary.nullable(),
};
